import { render, staticRenderFns } from "./TodayPosition.vue?vue&type=template&id=8cb3925c&scoped=true"
import script from "./TodayPosition.vue?vue&type=script&setup=true&lang=ts"
export * from "./TodayPosition.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TodayPosition.vue?vue&type=style&index=0&id=8cb3925c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb3925c",
  null
  
)

export default component.exports